export const mutationTypes = {
  GET_SEARCH_RESULTS_SUCCESS: 'GET_SEARCH_RESULTS_SUCCESS',
  GET_SEARCH_RESULTS_PENDING: 'GET_SEARCH_RESULTS_PENDING',
  GET_SEARCH_RESULTS_FAILURE: 'GET_SEARCH_RESULTS_FAILURE',
  DISTRIBUTE_CATEGORY_PENDING: 'DISTRIBUTE_CATEGORY_PENDING',
  DISTRIBUTE_CATEGORY_SUCCESS: 'DISTRIBUTE_CATEGORY_SUCCESS',
  DISTRIBUTE_CATEGORY_FAILURE: 'DISTRIBUTE_CATEGORY_FAILURE',
  RESET_STATE: 'RESET_STATE',
  GO_BACK_TO_RECENT_WORKSPACES: 'GO_BACK_TO_RECENT_WORKSPACES'
}

export default {
  mutationTypes
}
